import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { viewEnrollmentToolsDocument } from "src/services/view-enrollment-tools-document";
import { AsyncStatus } from "../../models/async-status";

export const fetchViewEnrollmentToolsDocument = createAsyncThunk(
  "fetch-view-enrollment-tools-document",
  async (
    {
      planId,
      empId,
      extension,
      resourceId,
      role,
    }: {
      planId: number;
      empId: number;
      extension: string;
      resourceId: number;
      role: string;
    },
    thunkApi
  ) => {
    return viewEnrollmentToolsDocument(
      planId,
      empId,
      extension,
      resourceId,
      role
    );
  }
);

type State = {
  status: AsyncStatus;
};

const initialState: State = {
  status: AsyncStatus.not_fetched,
};

const viewEnrollmentToolsDocumentSlice = createSlice({
  name: "view-enrollment-tools-document",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchViewEnrollmentToolsDocument.pending,
      (state, action) => {
        return { ...state, status: AsyncStatus.loading };
      }
    );
    builder.addCase(
      fetchViewEnrollmentToolsDocument.fulfilled,
      (state, action) => {
        return { ...state, ...action.payload, status: AsyncStatus.done };
      }
    );
    builder.addCase(
      fetchViewEnrollmentToolsDocument.rejected,
      (state, action) => {
        return {
          ...state,
          status: AsyncStatus.error,
        };
      }
    );
    builder.addDefaultCase((state, action) => state);
  },
});

export default viewEnrollmentToolsDocumentSlice.reducer;
